import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Audience`}</h1>
    <p>{`Use attributes to target an specific audience by using `}<a parentName="p" {...{
        "href": "http://jsonlogic.com/"
      }}>{`JsonLogic`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let userId = "676380e0-7793-44d6-9189-eb5868e17a86"
let experimentId = "experiment-2"

tesfy.getVariationId(experimentId: experimentId, userId: userId, attributes: "{ \\"countryCode\\": \\"ve\\" }") // nil
tesfy.getVariationId(experimentId: experimentId, userId: userId, attributes: "{ \\"countryCode\\": \\"us\\" }") // "0"
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      